import { Font } from '@/src/components';
import style from './style.module.scss';

export default function LandingPageFooter({ id = '' }: { id?: string }) {
  const footerContent = [
    {
      id: 'typography-footer-section-alamat',
      title: 'Alamat',
      content: `Jl. Jend. Sudirman No. Kav 44-46 RT. 14/ RW. 1
          Bend. Hilir, Tanah Abang
          Jakarta Pusat, DKI Jakarta, 10210`,
      link: '',
    },
  ];

  return (
    <div
      id={id}
      className={style.footer_landingpage}
    >
      <div className={style.footer_detail}>
        <img
          id={'image-footer-bri'}
          width={"100px"}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/logo-bri.webp`}
          alt="logo-bri"
        />
        {footerContent.map((item: any, index: number) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              gap: '12px',
            }}
          >
            <Font id={`typography-footer-section-${item.id}`} variant="subtitle-1-bold" color="white">
              {item?.title}
            </Font>
            {item.link.length ? (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '28px',
                  color: '#B4D4FC',
                  width: `${item.link.length ? 'max-content' : ''}`,
                }}
              >
                {item?.content}
              </a>
            ) : (
              <div
                style={{
                  display: "flex",
                  whiteSpace: "pre-line",
                }}
              >
                <Font variant="body-1-regular" color="white">
                  {item?.content}
                </Font>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className={style.copyright}>
        <Font id={'typography-footer-copyright'} variant="body-1-medium" color="white">
          © 2021 PT Bank Rakyat Indonesia (Persero) Tbk. | All Rights Reserved.
        </Font>
      </div>
    </div>
  )
}
